<template>
    <div>
        <Header />
        <base-section
            class="property-section"
            title="物件詳細"
        >
            <div class="main">
                <property-list
                    v-if="display"
                    :property="property"
                    @login="login"
                    @pushFavorite="favorite"
                    @share="share"
                />

                <div class="back-btn">
                    <base-button @click="moveToList">物件一覧に戻る</base-button>
                </div>
            </div>
        </base-section>

        <login-modal
            :dialogVisible="isLoginModal"
            @close="closeLoginModal"
            @login="toLogin"
        />

        <share-modal
            :dialogVisible="isShareModal"
            :property="shareProperty"
            @close="closeShareModal"
        />
    </div>
</template>

<script>
import Header from '../../components/Header/Header'
import PropertyList from '../../components/List/PropertyList'
import LoginModal from '../../components/organisms/modal/LoginModal'
import BaseButton from '../../components/atoms/button/BaseButton'
import BaseSection from '../../components/molecules/section/BaseSection'
import ShareModal from '../../components/organisms/modal/ShareModal'

import PropertyRepository from '../../backend/PropertyRepository'

export default {

    components: {
        Header,
        PropertyList,
        LoginModal,
        BaseButton,
        BaseSection,
        ShareModal
    },

    data() {
        return {
            property: {},
            isLoginModal: false,
            display: false,
            isShareModal: false,
            shareProperty: null
        }
    },

    computed: {
        id() {
            return this.$route.params.id
        }
    },

    mounted() {
        this.init()
    },

    methods: {

        // 初期表示処理
        async init() {
            const response = await PropertyRepository.getDetail(this.id)
            this.property = response.property
            this.display = true
        },

        // 認証していないときはログインモーダルを表示する
        login() {
            this.isLoginModal = !this.isLoginModal
        },

        //////////////////////////////////////////
        // LOGIN MODAL

        // ログインモーダルを閉じる
        closeLoginModal() {
            this.isLoginModal = false
        },

        // ログインモーダルの「ログインへ」ボタン押下時の処理
        toLogin() {
            this.$router.push({ name: 'login' })
        },

        // 物件一覧画面へ遷移
        moveToList() {
            this.$router.push({ name: 'top' })
        },

        //////////////////////////////////////////
        // FAVORITE

        // お気に入りの処理
        async favorite(property) {
            let message = ''
            let response = ''

            // お気に入り解除
            if (property.favorites) {
                response = await PropertyRepository.unfavorite(property)
                message = 'お気に入りから削除しました'

            // お気に入り登録
            } else {
                response = await PropertyRepository.favorite(property)
                message = 'お気に入りに登録しました'
            }

            if (response.status === 200) {
                this.$message({
                    message: message,
                    type: 'success'
                })

                this.changeFavorite(property)
            }
        },

        // お気に入りの表示を切り替える
        changeFavorite(property) {
            this.property.favorites = !property.favorites
        },

        ////////////////////////////////////
        // SHARE

        // SNSシェア
        share(property) {
            this.isShareModal = true
            this.shareProperty = property
        },
        // シェアモーダル
        closeShareModal() {
            this.isShareModal = false
        },
    }

}
</script>

<style lang="scss" scoped>
.property-section {
    margin-top: 50px;
}
.back-btn {
    margin: 20px;
}
</style>